import ActionButtons from 'common/navigation/components/action-buttons';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import TicketButton from 'tickets/ticket-button';
import { withRouter } from 'utils/withRouter';
import FiltersSidepanel from '../../../common/filters/filters-sidepanel';
import { additionalTabTypes, referenceTypes, ticketWorklistId } from '../../../utils/app-configs';
import WorkGridWrapper from '../../../workgrid/components/work-grid-wrapper';
import WorklistWrapper from '../../../worklist/components/worklist-wrapper';
import CreateView from '../../../worklist/containers/create-view-container';
import ManageViews from '../../../worklist/containers/manage-views-container';

const Wrapper = styled.div`
  margin: 15px;
`;

const AgWrapper = styled.div`
  width: calc(100% + 35px);
`;

const TicketWorklist = ({
  isDataLoading,
  filterDefinitions,
  updateFilters,
  updateView,
  activeFilters,
  menuVisible,
  match,
  views,
  renderConnectionStatus,
  renderMenu,
  clearWorklistData,
  filterGroups,
  isMainTicketPage = false,
  baseType,
}) => {
  const filterRef = useRef();

  const handleUpdateFilters = (filters) => {
    if (!isMainTicketPage) {
      const objectFilters = filters?.object || [];
      updateFilters({
        ...filters,
        object: objectFilters,
      });
    } else {
      updateFilters(filters);
    }
  };

  // ID can be optional (prefilled with match.params.worklistId)
  const handleRowClick = (item) => {
    window.open(
      // eslint-disable-next-line max-len
      `${window.location.origin}/ticket/${item.number}/${item.id}/details`, '_blank',
    );
  };

  const handleLinkedObjectClick = (item) => {
    window.open(
      // eslint-disable-next-line max-len
      `${window.location.origin}/${item.linkedObjectUri}/dashboard`, '_blank',
    );
  };

  const handleLinkedOrderClick = (item) => {
    window.open(
      // eslint-disable-next-line max-len
      `${window.location.origin}/${item.linkedOrderUri}/dashboard`, '_blank',
    );
  };

  const handleCustomerClick = (item) => {
    window.open(
      // eslint-disable-next-line max-len
      `${window.location.origin}/${item.customerUri}/dashboard`, '_blank',
    );
  };

  // FixedFilterValues gives the option to select and disable certain options
  // (=value of the object (type = array)) on a certain filter id (=key of the object).
  // When using this, always check if it is already implemented in the specific filter code base and
  // if it is passed to the filter in the filter.js
  const fixedFilter = match.params.objectId ? {
    object: baseType === referenceTypes.installedAt ?
      [`showChildren[${match.params.objectId}]`] :
      [match.params.objectId],
  } : {};

  return (
    <WorklistWrapper isTickets={true} baseType={baseType}>
      {match.params.objectId ?
        renderMenu(
          <ActionButtons>
            {renderConnectionStatus && renderConnectionStatus()}
            <TicketButton id={match.params.objectId} />
          </ActionButtons>,
        )
        : renderMenu()
      }
      <Routes>
        <Route
          path={'filterselect'}
          element={<FiltersSidepanel
            filterRef={filterRef}
            isDataLoading={isDataLoading}
            filterDefinitions={filterDefinitions}
            updateFilters={handleUpdateFilters}
            activeFilters={activeFilters}
            isPlanningBoard={true}
            filterGroups={filterGroups}
            isTickets={true}
            fixedFilterValues={fixedFilter}
            additionalTabs={[additionalTabTypes.columns]}
          />
          }
        />
        <Route
          path={'create-view'}
          element={<CreateView
            id={ticketWorklistId}
            filters={match.params.filters || ''}
            sort={match.params.sort || ''}
            updateView={updateView}
            views={views}
            expandOption={true}
          />
          }
        />
        <Route
          path={'manage-views'}
          element={<ManageViews id={ticketWorklistId} expandOption={true} />}
        />
      </Routes>
      <Outlet />
      <Wrapper data-test-id='ticket-worklist'>
        <AgWrapper>
          <WorkGridWrapper
            menuVisible={menuVisible}
            filterWidth={filterRef?.current?.clientWidth}
            handleOrderClick={handleRowClick}
            clearWorklistData={clearWorklistData}
            sizeToFit={true}
            worklistId={ticketWorklistId}
            isTickets={true}
            masterDetail={true}
            isMainTicketPage={isMainTicketPage}
            selectable={true}
            columnActions={{
              Description: handleRowClick,
              LinkedObject: handleLinkedObjectClick,
              LinkedOrder: handleLinkedOrderClick,
              Customer: handleCustomerClick,
            }}
            fixedFilterValues={fixedFilter}
          />
        </AgWrapper>
      </Wrapper>
    </WorklistWrapper>
  );
};

TicketWorklist.propTypes = {
  isDataLoading: PropTypes.bool,
  filterDefinitions: PropTypes.array,
  updateFilters: PropTypes.func,
  updateView: PropTypes.func,
  activeFilters: PropTypes.object,
  menuVisible: PropTypes.bool,
  match: PropTypes.object.isRequired,
  views: PropTypes.array,
  renderConnectionStatus: PropTypes.func,
  renderMenu: PropTypes.func,
  clearWorklistData: PropTypes.func,
  filterGroups: PropTypes.array,
  isMainTicketPage: PropTypes.bool,
  baseType: PropTypes.string,
};

export default withRouter(TicketWorklist);
